<template>
  <div>
    <!--Header-->
    <div class="header bg-gradient-success pt-5 pb-7">
      <b-container>
        <div class="header-body mt-5">
          <b-row align-v="center">
            <b-col lg="6">
              <div class="pr-5">
                <slot name="header" />
              </div>
            </b-col>
            <b-col lg="6">
              <slot name="hero-image">
                <b-img class="hero-image" src="/img/hero_image_12.png" />
              </slot>
            </b-col>
          </b-row>
        </div>
      </b-container>
      <div class="separator separator-bottom separator-skew zindex-100">
        <svg
          x="0"
          y="0"
          viewBox="0 0 2560 100"
          preserveAspectRatio="none"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
        >
          <polygon
            class="fill-default"
            points="2560 0 2560 100 0 100"
          ></polygon>
        </svg>
      </div>
    </div>
    <!-- Page content -->
    <section class="bg-default pt-6">
      <b-row class="justify-content-center text-center">
        <slot name="second"></slot>
      </b-row>
      <b-row class="justify-content-center text-center">
        <slot name="second-image"></slot>
      </b-row>
    </section>

    <slot name="feature-breakdown"></slot>

    <section class="py-7 bg-white">
      <b-container>
        <b-row class="row-grid justify-content-center">
          <b-col lg="8" class="text-center">
            <h2 class="display-3">
              BoltScale is a
              <span class="text-success">developer's best friend.</span>
            </h2>
            <p class="lead">
              Never get blindsided by downtime again. Get started now, for free.
            </p>
            <div class="btn-wrapper">
              <router-link to="/register">
                <base-button>
                  <span class="btn-inner--text">Get started for free</span>
                </base-button>
              </router-link>
            </div>
          </b-col>
        </b-row>
      </b-container>
    </section>
  </div>
</template>
<script>
//import AsyncWorldMap from "@/components/WorldMap/AsyncWorldMap.vue";

//import { Tooltip } from "element-ui";
export default {
  name: "features",
  components: {
    //   AsyncWorldMap,
    // [Tooltip.name]: Tooltip
  }
};
</script>

<style>
.iphone-hero-img {
  height: 300px;
  width: auto;
}
.card-snippet {
  text-align: center;
}
.main-content {
  overflow: hidden;
}

.hero-image {
  margin-top: 25px;
  width: 800px;
  margin-bottom: -94px;
  box-shadow: 0 1rem 3rem rgba(0, 0, 0, 0.175) !important;
  /*box-shadow: 1px 1px 100px 51px rgba(25, 43, 77, 0.1);*/
}
</style>
